import { makeStyles } from '@material-ui/core';

export const inputStyles = makeStyles((theme) => ({
  input: {
    color: theme.palette.primary.main,
  },
}));
